import settings from '../../../../src/data/settings.json';

class URLResolver {

	static getCurrentEnvironment(){
		return settings.defaultEnvironment;
	}

	static getRemoteURL(){
		return settings.environments[settings.defaultEnvironment].remoteUrl;
	}

	static getUpdatedURLwithParams(url,paramsMap){
		let i=0;
		var tempString = [];
		var obj = {};
		paramsMap.forEach(function(value, key) {
			/*if(i==0){
				tempString='?'+key+'='+value;
			}else {
				tempString=tempString+'&'+key+'='+value;
			}
			i++;
			*/
			obj[key] = value;
			
  		});
  		//url=url+tempString;
  		//return url;
  		return obj;
	}
}

export default URLResolver;